import {SxProps, Theme} from '@mui/material';
import theme from 'src/theme';

export const popoverSx: SxProps<Theme> = {
    '& .MuiPaper-root': {
        maxWidth: theme.spacing(200 / 8),
        width: '100%',
        p: 1,
    },
};
